import React, {useContext} from 'react'
import classNames from 'classnames'
import {Redirect} from 'react-router'
import HeaderlessLayout from 'Src/components/Layouts/HeaderlessLayout'
import {PageProvider} from 'Src/components/pages/SoftPull/PageContext'
import Footer from 'Src/components/SoftPull/Footer'
import Form from 'Src/components/SoftPull/Form'
import Header from 'Src/components/SoftPull/Header'
import PlaceholderSpinner from 'Src/components/Spinners/PlaceholderSpinner'
import {SOFT_PULL_STATUS} from 'Src/constants'
import {useCustomerStateContext} from 'Src/contexts/CustomerContext'
import {useFrameContext} from 'Src/contexts/FrameContext'
import {NavDispatchContext} from 'Src/contexts/NavContext'
import {getIsProduction} from 'Src/utilities/Helpers'
import {TOKEN_STATE} from 'Src/utilities/useToken'

const SoftPull = () => {
  const {
    customerData: {softPullCreditReport},
    softPullData,
  } = useCustomerStateContext()
  const navDispatch = useContext(NavDispatchContext)
  const {tokenState} = useFrameContext()
  const isSoftPullLoading = softPullCreditReport === SOFT_PULL_STATUS.LOADING
  const isSoftPullUnavailable = softPullCreditReport === SOFT_PULL_STATUS.UNAVAILABLE
  const isSoftPullAvailable = !!softPullCreditReport
  const isNotProduction = !getIsProduction()

  // If user is logged-in and soft pull report is unavailable, take them to Desking.
  if (tokenState === TOKEN_STATE.AUTHENTICATED && isSoftPullUnavailable && softPullData) {
    return <Redirect to="/" />
  }

  // If user is logged-in and already has a soft pull report, take them to Desking.
  if (tokenState === TOKEN_STATE.AUTHENTICATED && !isSoftPullLoading && isSoftPullAvailable) {
    return <Redirect to="/" />
  }

  if (tokenState === TOKEN_STATE.LOADING) {
    return <PlaceholderSpinner className={classNames({'tw-bg-red-500': isNotProduction})} />
  }

  if (tokenState === TOKEN_STATE.AUTHENTICATED && isSoftPullLoading) {
    return <PlaceholderSpinner className={classNames({'tw-bg-green-500': isNotProduction})} />
  }

  const handlePageClose = () => {
    navDispatch({type: 'closeSlideOut'})
  }

  return (
    <PageProvider value={{handlePageClose}}>
      <HeaderlessLayout onClose={handlePageClose}>
        <Header />
        <Form />
        <Footer />
      </HeaderlessLayout>
    </PageProvider>
  )
}

export default SoftPull
